import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useCanViewPersonChangeHistoryBool,
  useRequireCapability
} from "@/hooks/useCapabilities";

export function usePersonChangeHistoryAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonChangeHistory = useCanViewPersonChangeHistoryBool();

  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewPersonChangeHistory });

  return {
    loaded,
    canViewPersonChangeHistory
  };
}
